import React from "react";
import { FieldRendererProps } from "../types";
import {
  FileInput, FileUploadContainer, UploadIcon, UploadText,
  FilePreviewContainer, FilePreview, FileIcon, FileInfo, FileName,
  FileSize, FileActions, FileActionButton, ErrorMessage, PremiumWarning,
} from "../styles";
import { TipoFormulario } from "../../../services/constantes";
import { FaEye, FaUpload, FaTrash, FaImage } from "react-icons/fa";
import { FaStar } from "react-icons/fa";

export const ImageFieldRenderer: React.FC<FieldRendererProps> = ({
  campo, modo, errors, planoPremium,
  imagePreview, dragActive,
  handleImageChange, handleImageRemove, handleDrag, handleDrop, handleViewImage,
}) => (
  <>
    {!planoPremium && (
      <PremiumWarning>
        <FaStar /> Apenas para plano premium
      </PremiumWarning>
    )}
    {modo !== TipoFormulario.tpVisualizacao && planoPremium && (
      <>
        <FileInput
          id={`file-input-${campo.nome}`}
          type="file"
          accept="image/*"
          onChange={(e) => {
            const fileInput = e.target as HTMLInputElement;
            const file = fileInput.files?.[0];
            if (file) {
              handleImageChange?.(campo.nome, file);
              fileInput.value = '';
            }
          }}
        />
        <FileUploadContainer
          className={dragActive?.[campo.nome] ? 'active' : ''}
          onClick={() => document.getElementById(`file-input-${campo.nome}`)?.click()}
          onDragEnter={(e) => handleDrag?.(e, campo.nome, true)}
          onDragLeave={(e) => handleDrag?.(e, campo.nome, false)}
          onDragOver={(e) => e.preventDefault()}
          onDrop={(e) => handleDrop?.(e, campo.nome, 'image')}
        >
          <UploadIcon><FaImage /></UploadIcon>
          <UploadText>
            {dragActive?.[campo.nome]
              ? 'Solte a imagem aqui'
              : 'Arraste e solte uma imagem ou clique para selecionar'}
          </UploadText>
        </FileUploadContainer>
      </>
    )}
    <FilePreviewContainer>
      {imagePreview?.[campo.nome] ? (
        <FilePreview empty={false}>
          <FileIcon><FaImage /></FileIcon>
          <FileInfo>
            <FileName>Imagem</FileName>
            <FileSize>Clique no ícone para ver</FileSize>
          </FileInfo>
          <FileActions>
            <FileActionButton
              className="view"
              onClick={(e: any) => { e.preventDefault(); handleViewImage?.(campo.nome); }}
              title="Visualizar imagem"
            >
              <FaEye />
            </FileActionButton>
            {modo !== TipoFormulario.tpVisualizacao && (
              <FileActionButton
                className="remove"
                onClick={(e: any) => { e.preventDefault(); handleImageRemove?.(campo.nome); }}
                title="Remover imagem"
              >
                <FaTrash />
              </FileActionButton>
            )}
          </FileActions>
        </FilePreview>
      ) : (
        <FilePreview empty={true} />
      )}
    </FilePreviewContainer>
    {errors[campo.nome] && <ErrorMessage>{errors[campo.nome]}</ErrorMessage>}
  </>
);
